import { AsyncThunkAction } from 'actions/actions.types'
import { muteProfileApi, unmuteProfileApi } from 'api/mute/toggleMuteProfileApi'

export const toggleMuteAction =
  (isMute: boolean, userIds: number[]): AsyncThunkAction =>
  async (dispatch) => {
    if (isMute) {
      return await dispatch(unmutePlainAction(userIds))
    }

    return await dispatch(mutePlainAction(userIds))
  }

export const MUTE_PROFILE = 'MUTE_PROFILE' as const

export const mutePlainAction = (userIds: number[]) => ({
  type: MUTE_PROFILE,
  userIds,
  promise: () => muteProfileApi(userIds),
})

export const UNMUTE_PROFILE = 'UNMUTE_PROFILE' as const

export const unmutePlainAction = (userIds: number[]) => ({
  type: UNMUTE_PROFILE,
  userIds,
  promise: () => unmuteProfileApi(userIds),
})

export type ToggleMuteTypes =
  | ReturnType<typeof mutePlainAction>
  | ReturnType<typeof unmutePlainAction>
